import { Component } from '@angular/core';
import { Location } from '@angular/common';
@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss',
  standalone: false,
})
export class TermsAndConditionsComponent {
  constructor(protected location: Location) {}
}
